<i18n>
  {
    "pt_BR": {
      "option": "Selecione uma opção",
      "utiliza-rd": {
        "label": "Você já utiliza o RD Station?",
        "no": "Não",
        "yes": "Sim"
      },
      "plano-rd": {
        "label": "Qual seu plano RD Station?",
        "basic": "Basic",
        "pro": "Pro",
        "enterprise": "Enterprise",
        "agencia": "Sou uma agência"
      },
      "no-rd": {
        "label": "Tem interesse em utilizar o RD Station?",
        "0": "Sim, para a minha empresa",
        "1": "Sim, sou uma agência",
        "2": "Não, já utilizo outra ferramenta",
        "3": "Na verdade, nunca ouvi falar"
      }
    }
  }
</i18n>

<template>
  <div class="signup-form--step step-2 active">
    <div class="signup-input--container">
      <label v-t="'utiliza-rd.label'"></label>
      <select id="signupUtilizaRD" class="signup-input--select" v-model="form['utiliza-rd']">
        <option value="" disabled selected v-t="'option'"></option>
        <option value="Sim" v-t="'utiliza-rd.yes'"></option>
        <option value="Não" v-t="'utiliza-rd.no'"></option>
      </select>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('utiliza-rd')"></p>
      <p class="login-input--error" v-if="! form.has('utiliza-rd')"></p>
    </div>

    <div class="signup-input--container" v-if="form['utiliza-rd'] == 'Sim'">
      <label v-t="'plano-rd.label'"></label>
      <select id="signupUtilizaRD" class="signup-input--select" v-model="form['plano-rd']">
        <option value="" disabled selected v-t="'option'"></option>
        <option value="Basic" v-t="'plano-rd.basic'"></option>
        <option value="Pro" v-t="'plano-rd.pro'"></option>
        <option value="Enterprise" v-t="'plano-rd.enterprise'"></option>
        <option value="Sou uma agência" v-t="'plano-rd.agencia'"></option>
      </select>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('plano-rd')"></p>
      <p class="login-input--error" v-if="! form.has('plano-rd')"></p>
    </div>

    <div class="signup-input--container" v-if="form['utiliza-rd'] == 'Não'">
      <label v-t="'no-rd.label'"></label>
      <select id="signupUtilizaRD" class="signup-input--select" v-model="form['no-rd']">
        <option value="" disabled selected v-t="'option'"></option>
        <option value="0" v-t="'no-rd.0'"></option>
        <option value="1" v-t="'no-rd.1'"></option>
        <option value="2" v-t="'no-rd.2'"></option>
        <option value="3" v-t="'no-rd.3'"></option>
      </select>
      <p class="signup-input--error active" :key="message" v-text="message" v-for="message in form.error('no-rd')"></p>
      <p class="login-input--error" v-if="! form.has('no-rd')"></p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      form: {
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Auth/Steps/Second.vue